import { Router } from "@angular/router";
import { DashboardService } from "./../../../dashboard.service";
import { Component, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { AddClientModalService } from "./add-client-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { ConversationsService } from "../../../conversations/conversations.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { NgIf, NgClass } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "app-modal-add-client",
    templateUrl: "./addClientModal.component.html",
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        NgClass,
    ]
})
export class AddClientModalComponent implements OnInit {
  public invited_to: any = null;
  public name: any = null;

  inviteForm: UntypedFormGroup;
  formUtil: FormUtil;
  inviteFormSubmitAttempt: boolean;
  availableUsers = [];
  newUser: boolean = true;
  inviteType = "";

  inviteTypeSelection = this.formBuilder.group({
    type: "new",
  });

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    private AddClientModalService: AddClientModalService,
    private localStorage: LocalStorageService,
    private dashboardService: DashboardService,
    private conversationsService: ConversationsService,
    public dashboardStore: DashboardStore,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formUtil = new FormUtil();

    this.inviteForm = this.formBuilder.group({
      name: [null, []],
      email: [null, []],
      company_name: [null, []],
    });
  }

  public ngOnChanges(changes: SimpleChanges) {}

  inviteClient(): void {
    this.inviteFormSubmitAttempt = true;

    console.log("inviteClient");

    if (this.inviteForm.valid) {
      this.dashboardService.show_loading.next(true);
      this.accountantService
        .invite_client(
          this.inviteForm.get("name").value,
          this.inviteForm.get("email").value,
          this.inviteForm.get("company_name").value,
          2,
          this.invited_to,
          2
        )
        .then(
          (res: any) => {
            console.log(res);
            this.AddClientModalService.invite = res.invite;

            this.dashboardService.show_loading.next(false);
            this.toastr.success(res.message);
            if (res.company) {
              this.dashboardStore.addClient(res.company);
              this.router.navigate([`./practice/workspaces`, res.company.id]);
            }
            this.bsModalRef.hide();
          },
          (err) => {
            console.log("error", err);
            this.toastr.error(err.error.message);

            this.dashboardService.show_loading.next(false);
          }
        );
    }
  }
}
